import React from 'react';
import ReactDOM from 'react-dom/client';
import './shared/design/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Remove StrictMode in development to prevent double mounting/unmounting cycles
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
